<template>
    <v-main>
        <div id="core-view">
            <v-fade-transition mode="out-in">
                <router-view />
            </v-fade-transition>

            <v-snackbar v-model="enabled" :timeout="timeout" :bottom="true" :color="type" dark>
                <div class="snackbar-text">
                    <span>
                        {{title}} - &nbsp;
                    </span>
                    <span v-html="description" />
                </div>
                <div class="snackbar-close">
                    <v-icon size="16" @click="closeSnackbar">
                        mdi-close-circle
                    </v-icon>
                </div>                
            </v-snackbar>

            <message-box />
            <confirm-message-box />

            <error-message-box />            
        </div>
        
        <core-footer />
    </v-main>
</template>

<script>
import { mapGetters , mapMutations } from 'vuex'

import ConfirmMessageBox from '@/components/material/ConfirmationDialog'
import ErrorMessageBox from '@/components/material/ErrorsDialog'
import MessageBox from '@/components/material/MessageBox'

export default {
    components:{
        "error-message-box": ErrorMessageBox,
        "confirm-message-box": ConfirmMessageBox,
        "message-box": MessageBox
    },
    computed:{
        enabled:{
            get(){
                return this.$store.state.app.snackbar.enabled;
            },
            set(value){
                let snackbar = this.$store.state.app.snackbar;
                snackbar.enabled = value;
                this.setSnackbar(snackbar);  
            }
        },
        type(){
            return this.$store.state.app.snackbar.type;
        },
        timeout(){
            return this.$store.state.app.snackbar.timeout;
        },          
        title(){
            return this.$store.state.app.snackbar.title;
        },
        description(){
            return this.$store.state.app.snackbar.description;
        },    
        showMessageBox(){
            return this.$store.state.app.messageBox.show;
        },                   
        closeText(){
            return this.$t("Common.close");
        }
    }, 
    methods:{
        ...mapMutations("app", [ "setSnackbar" ]),
        closeSnackbar(){
            let snackbar = this.$store.state.app.snackbar;
            snackbar.enabled = false;
            this.setSnackbar(snackbar);      
        },
    },
    metaInfo () {
        return {
            title: 'Sonda Workspace'
        }
    }
}
</script>

<style>
#core-view {
    padding-top: 80px;
    padding-bottom: 60px;
}
.snackbar-text{
    width: 98%;
    float: left;    
}
.snackbar-close{
    width: 2%;
    float: right;
}
</style>
